import { render, staticRenderFns } from "./modalTransportationSegmentCreate.vue?vue&type=template&id=0f0e5204&scoped=true"
import script from "./modalTransportationSegmentCreate.vue?vue&type=script&lang=js"
export * from "./modalTransportationSegmentCreate.vue?vue&type=script&lang=js"
import style0 from "./modalTransportationSegmentCreate.vue?vue&type=style&index=0&id=0f0e5204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0e5204",
  null
  
)

export default component.exports